import React, { PropTypes, Component } from 'react'
import Modal from 'react-modal'
import cn from 'classnames'

class ConfirmDialog extends Component {

  componentDidMount() {
    setTimeout(() => {
      this._focus.focus()
    }, 0)
  }

  render() {
    const { closeDialog, confirmAction, msg, btnClass, pending } = this.props

    const btnCl = cn(btnClass, 'btn')
    return (
      <Modal
        className="modal-dialog modal-sm modal-confirm"
        overlayClassName="modal-overlay confirm"
        onRequestClose={closeDialog}
        contentLabel="confirm-modal"
        isOpen
      >
        <div className="modal-content">
          <div className="modal-body">{msg}</div>
          <div className="modal-footer">
            <button type="button" onClick={closeDialog} disabled={pending} className="btn btn-link">Cancel</button>
            <button ref={(c) => this._focus = c} type="button" onClick={confirmAction} disabled={pending} className={btnCl}>Confirm</button>
          </div>
        </div>
      </Modal>
    )
  }
}

ConfirmDialog.propTypes = {
  msg: PropTypes.string,
  btnClass: PropTypes.string,
  pending: PropTypes.bool,
  closeDialog: PropTypes.func,
  confirmAction: PropTypes.func,
}

export default ConfirmDialog



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog/index.js